import { CookieControlModal } from "./cookie-control-modal";
import { CookieNotice } from "./cookie-notice";
import { CookieConsentProvider } from "./providers";

import type { CookieConsentProps } from "./cookie-consent.types";

export function CookieConsent({ ...props }: Readonly<CookieConsentProps>) {
  return (
    <CookieConsentProvider {...props}>
      <CookieNotice />
      <CookieControlModal />
    </CookieConsentProvider>
  );
}
